import api from "../../../api/axios";

export const fetchNotificationList = (params) =>
  api.get("/notifications/", { params }).then((res) => res.data);

export const fetchUnreadNotificationCount = () =>
  api.get("/notifications/unread-count/").then((res) => res.data);

export const markNotificationReadById = (id, options = {}) => {
  const body = {};
  if (
    options
    && options.expectedLatestMessageId != null
    && options.expectedLatestMessageId !== ""
  ) {
    body.expected_latest_message_id = String(options.expectedLatestMessageId);
  }
  return api.post(`/notifications/${id}/mark-read/`, body).then((res) => res.data);
};

export const markAllNotificationsRead = () =>
  api.post("/notifications/mark-all-read/").then((res) => res.data);
